import { isMobile } from "../isMobile/isMobile";

export function addVideoToPage() {
  if (isMobile()) {
    return false;
  }
  const videoContainers = document.getElementsByClassName("load-video");

  for (let i = 0; i < videoContainers.length; i++) {
    if (!videoContainers[i].hasAttribute("data-videosrc")) {
      continue;
    }
    let videosrc = videoContainers[i].getAttribute("data-videosrc");
    if (!videosrc) {
      continue;
    }

    let video = document.createElement("video");
    video.classList.add("video-bg__video");
    video.loop = true;
    video.muted = true;
    video.autoplay = true;

    if (video.canPlayType("video/mp4").length > 0) {
      video.src = videosrc;
    } else {
      continue;
    }
    videoContainers[i].appendChild(video);
  }
}
